
// Configuration for WordPress API
export const API_BASE_URL = 'https://blog.gildy.it/wp-json/wp/v2';

export const DEFAULT_FEATURED_IMAGE = 'https://images.unsplash.com/photo-1610375461369-d613b564c5bd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=500&q=80';
export const DEFAULT_AUTHOR = {
  name: 'Autore Gildy',
  avatar: 'https://randomuser.me/api/portraits/men/1.jpg'
};

export const READING_SPEED_WPM = 200; // Words per minute for reading time calculation
